import { render, staticRenderFns } from "./AdsOnTop.vue?vue&type=template&id=17f382a8&scoped=true&"
import script from "./AdsOnTop.vue?vue&type=script&lang=js&"
export * from "./AdsOnTop.vue?vue&type=script&lang=js&"
import style0 from "./AdsOnTop.vue?vue&type=style&index=0&id=17f382a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f382a8",
  null
  
)

export default component.exports